import axios from "axios";
import { Box, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { useEffect, useMemo, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { IoMdDownload } from "react-icons/io";
import axiosInstance from "../utils/axiosInstance";
import CustomTable from "../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import axiosInstanceMainUrl from "../utils/axiosInstanceMainUrl";
import Loader from "../components/customTable/Loader";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import MuiSelectionModal from "../components/muiselectionmodal/MuiSelectionModal";
export default function SellQuoteMmtc() {
  const [getQuoteLoading, setGetQuoteLoading] = useState(false);
  const [uploadQuoteLoading, setuploadQuoteLoading] = useState(false);
  const [uploadData, setuploadData] = useState("");
  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [results, setresults] = useState([]);
  const [loader, setloader] = useState();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    status: "",
  });
  const [status, setStatus] = useState("");
  const roleResponse = useSelector((state) => state.login.login.role);
  const config = { ...date };
  const apicall = async () => {
    try {
      setloader(true);
      const url = `/admin_panel/trade/failed/list`;
      const response = await axiosInstanceMainUrl.get(url, { config });
      // console.log("-------------------->", response)

      const { data, error, message } = response.data;
      console.log(
        "API RESPONSE:------------------------------------------>><<>",
        response.data,
      );
      if (!error) {
        setresults(data);
        setloader(false);
      }
    } catch (error) {}
  };

  const [file, setFile] = useState(null);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleHistoryDateChange = (e) => {
    const { name, value } = e.target;
    setHistoryDate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleFileChange = (e) => {
  //     setFile(e.target.files[0])
  // }

  // const handleGetQuote = async (e) => {
  //     e.preventDefault();
  //     if (!date.startDate || !date.endDate) {
  //         Swal.fire({
  //             icon: "warning",
  //             text: "Please select start Date & End Date first",
  //         })
  //         return
  //     }
  //     try {
  //         setGetQuoteLoading(true)
  //         const token = localStorage.getItem("token")
  //         const URL = import.meta.env.VITE_MAIN_URL

  //         const res = await axios.get(
  //             `${URL}/mmtc/sell/quote/excel`,
  //             {
  //                 params: {
  //                     // startDate: "2026-01-28",
  //                     // endDate: "2026-01-28",
  //                     startDate: date.startDate || "",
  //                     endDate: date.endDate || "",
  //                 },
  //                 responseType: "blob",
  //                 headers: {
  //                     Authorization: `Bearer ${token}`,
  //                 },
  //             }
  //         )

  //         const contentType = res.headers["content-type"]

  //         if (contentType?.includes("application/json")) {
  //             const text = await res.data.text()
  //             const json = JSON.parse(text)
  //             if (json?.error === true) {
  //                 Swal.fire({
  //                     icon: "error",
  //                     text: json.message || "Failed to download the Excel file.",
  //                 })
  //                 return
  //             }
  //         }

  //         // Create Blob
  //         const blob = new Blob([res.data], {
  //             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //         })

  //         // Create download URL
  //         const url = window.URL.createObjectURL(blob)
  //         const link = document.createElement("a")
  //         link.href = url

  //         // Get filename from headers (axios style)
  //         const contentDisposition = res.headers["content-disposition"]
  //         const filename = contentDisposition
  //             ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
  //             : `sell_quotes_${new Date().toISOString().split("T")[0]}.xlsx`

  //         link.setAttribute("download", filename)
  //         document.body.appendChild(link)
  //         link.click()

  //         // Cleanup
  //         link.remove()
  //         window.URL.revokeObjectURL(url)

  //         setDate({
  //             startDate: "",
  //             endDate: "",
  //         })

  //         Swal.fire({
  //             icon: "success",
  //             text: "Your Excel file is being downloaded.",
  //         })
  //     } catch (error) {
  //         console.error("ERROR IN GET-QUOTE =========>>>>", error)
  //         Swal.fire({
  //             icon: "error",
  //             text:
  //                 error || error?.response?.data?.message ||
  //                 "Failed to download the Excel file.",
  //         })
  //     } finally {
  //         setGetQuoteLoading(false)
  //     }
  // }

  // const handleUpload = async () => {
  //     if (!file) {
  //         Swal.fire({
  //             icon: "warning",
  //             text: "Please select an Excel file first",
  //         })
  //         return
  //     }

  //     try {
  //         setuploadQuoteLoading(true)
  //         const token = localStorage.getItem("token")
  //         const URL = import.meta.env.VITE_MAIN_URL
  //         const formData = new FormData()
  //         formData.append("file", file)
  //         const res = await axios.post(
  //             `${URL}/mmtc/upload/sell/quote/execute`,
  //             formData,
  //             {
  //                 headers: {
  //                     Authorization: `Bearer ${token}`,
  //                     "Content-Type": "multipart/form-data",
  //                 },
  //             }
  //         )

  //         console.log("UPLOAD QUOTE API =========>>", res)
  //         setuploadData(res.data.data)
  //         setFile(null)

  //         Swal.fire({
  //             icon: "success",
  //             text: "Excel file uploaded successfully.",
  //         })
  //     } catch (error) {
  //         console.error("ERROR IN UPLOAD-QUOTE =========>>>>", error)

  //         Swal.fire({
  //             icon: "error",
  //             text:
  //                 error?.response?.data?.message ||
  //                 "Failed to upload the Excel file.",
  //         })
  //     } finally {
  //         setuploadQuoteLoading(false)
  //     }
  // }

  // const [historyDate, setHistoryDate] = useState({
  //     startDate: "",
  //     endDate: "",
  // })

  const [historyLoading, setHistoryLoading] = useState();
  const [historyData, setHistoryData] = useState();

  const handleGetHistorySubmit = (e) => {
    e.preventDefault();
    if (!date.startDate || !date.endDate) {
      Swal.fire({
        icon: "warning",
        text: "Please select start Date & End Date first",
      });
      return;
    }
    // handleGetHistoryData()
    apicall();
  };

  useEffect(() => {
    apicall();
  }, []);

  // const handleGetHistoryData = async () => {
  //     try {
  //         setHistoryLoading(true)
  //         const res = await axiosInstance.get('/mmtc/sell/quote/list',
  //             {
  //                 params: {
  //                     // startDate: "2026-01-28",
  //                     // endDate: "2026-01-28",
  //                     startDate: historyDate.startDate || "",
  //                     endDate: historyDate.endDate || "",
  //                 },
  //             }
  //         )

  //         if (res.data.error) {
  //             Swal.fire({
  //                 icon: "error",
  //                 text: res.data.message || "Failed to download the Excel file.",
  //             })
  //             return
  //         }

  //         setHistoryData(res.data.data || [])
  //     } catch (error) {
  //         console.error("ERROR IN GET-QUOTE =========>>>>", error)
  //         Swal.fire({
  //             icon: "error",
  //             text:
  //                 error || error?.response?.data?.message ||
  //                 "Failed to download the Excel file.",
  //         })
  //     } finally {
  //         setHistoryLoading(false)
  //     }
  // }

  // useEffect(() => {
  //     handleGetHistoryData()
  // }, [])

  const columnHelper = createMRTColumnHelper();

  // const columns = [
  //     columnHelper.accessor("_id", {
  //         header: "ID",
  //         size: 30,
  //         Cell: ({ cell }) => {
  //             const handleCopy = () => {
  //                 navigator.clipboard.writeText(cell.row.original?._id);
  //                 toast.success("Copied to clipboard!");
  //             };
  //             return (
  //                 <Tooltip title={cell.row.original?._id}>
  //                     <IconButton onClick={handleCopy}>
  //                         <ContentCopy />
  //                     </IconButton>
  //                 </Tooltip>
  //             );
  //         },
  //     }),
  //     columnHelper.accessor("customerRefNo", {
  //         header: "customerRefNo",
  //         size: 150,
  //         Cell: ({ cell }) => {
  //             const handleCopy = () => {
  //                 navigator.clipboard.writeText(cell.row.original?.customerRefNo?._id);
  //                 toast.success("Copied to clipboard!");
  //             };
  //             return (
  //                 <Tooltip title={cell.row.original?.customerRefNo?._id}>
  //                     <span>
  //                         <IconButton onClick={handleCopy}>
  //                             <ContentCopy />
  //                         </IconButton>
  //                         {cell.row.original?.customerRefNo?.name}
  //                     </span>
  //                 </Tooltip>
  //             );
  //         },
  //     }),
  //     columnHelper.accessor("transactionId", {
  //         header: "Transaction Id",
  //         size: 150,
  //         Cell: ({ cell }) => {
  //             const handleCopy = () => {
  //                 navigator.clipboard.writeText(cell.row.original?.transactionId);
  //                 toast.success("Copied to clipboard!");
  //             };
  //             return (
  //                 <Tooltip title={cell.row.original?.transactionId}>
  //                     <span>
  //                         <IconButton onClick={handleCopy}>
  //                             <ContentCopy />
  //                         </IconButton>
  //                         {cell.row.original?.transactionId || "N/A"}
  //                     </span>
  //                 </Tooltip>
  //             );
  //         },
  //     }),
  //     columnHelper.accessor("phone", {
  //         header: "Phone",
  //     }),
  //     columnHelper.accessor("amount", {
  //         header: "Amount",
  //     }),
  //     columnHelper.accessor("metal_type", {
  //         header: "Metal Type",
  //     }),
  //     columnHelper.accessor("refinery", {
  //         header: "Refinery",
  //     }),
  //     columnHelper.accessor("redeemed", {
  //         header: "Redeemed",
  //         Cell: (cell) => cell.row.original.redeemed ? <span style={{ color: "green" }}>yes</span> : <span style={{ color: "red" }}>No</span>
  //     }),
  //     columnHelper.accessor("status", {
  //         header: "status",
  //         Cell: (cell) => cell.row.original.status
  //     }),
  //     columnHelper.accessor("self", {
  //         header: "Self",
  //         Cell: (cell) => cell.row.original.self ? <span style={{ color: "green" }}>yes</span> : <span style={{ color: "red" }}>No</span>
  //     }),
  //     columnHelper.accessor("createdAt", {
  //         header: "Created At",
  //         Cell: (cell) => cell.row.original.createdAt.split("T")[0],
  //     }),
  // ];

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerRefNo", {
      header: "customerRefNo",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("name", {
      header: "Name",
      size: 180,
    }),

    columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 180,
    }),

    columnHelper.accessor("refinery", {
      header: "Refinery",
      size: 180,
    }),

    columnHelper.accessor("type", {
      header: "Type",
      size: 180,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 180,
    }),

    // columnHelper.accessor("transactionRefNo", {
    //     header: "Transaction Ref No",
    //     size: 180,
    // }),

    // columnHelper.accessor("transactionRefNo", {
    //     header: "Transaction Ref No",
    //     size: 220,
    //     Cell: ({ cell }) => {
    //         const value = cell.getValue();
    //         const handleCopy = () => {
    //             navigator.clipboard.writeText(value);
    //             toast.success("Copied to clipboard!");
    //         };
    //         return (
    //             <Tooltip title={value}>
    //                 <IconButton onClick={handleCopy}>
    //                     <ContentCopy fontSize="small" />
    //                 </IconButton>
    //             </Tooltip>
    //         );
    //     },
    // }),

    // columnHelper.accessor("calculationType", {
    //     header: "Calculation Type",
    //     size: 80,
    // }),

    // columnHelper.accessor("metalType", {
    //     header: "Metal Type",
    //     size: 120,
    // }),

    // columnHelper.accessor("quantity", {
    //     header: "Quantity",
    //     size: 100,
    // }),

    // columnHelper.accessor("metalRate", {
    //     header: "Metal Rate",
    //     size: 120,
    // }),

    // columnHelper.accessor("preTaxAmount", {
    //     header: "Pre-Tax Amount",
    //     size: 140,
    // }),

    // columnHelper.accessor("totalAmount", {
    //     header: "Total Amount",
    //     size: 140,
    // }),

    // columnHelper.accessor("status", {
    //     header: "Status",
    //     size: 120,
    // }),

    // // 👤 Customer Details
    // columnHelper.accessor("customerNameInBatuk", {
    //     header: "Customer Name Batuk",
    //     size: 180,
    // }),
    // columnHelper.accessor("customerNameInMmtc", {
    //     header: "Customer Name MMTC",
    //     size: 180,
    // }),

    // columnHelper.accessor("mobileNoInBatuk", {
    //     header: "Mobile No Batuk",
    //     size: 140,
    // }),
    // columnHelper.accessor("mobileNoInMmtc", {
    //     header: "Mobile No MMTC",
    //     size: 140,
    // }),

    // columnHelper.accessor("panNoInBatuk", {
    //     header: "PAN Batuk",
    //     size: 120,
    // }),
    // columnHelper.accessor("panNoInMmtc", {
    //     header: "PAN MMTC",
    //     size: 120,
    // }),

    // columnHelper.accessor("dobInBatuk", {
    //     header: "DOB Batuk",
    //     size: 120,
    // }),

    // columnHelper.accessor("dobInMmtc", {
    //     header: "DOB MMTC",
    //     size: 120,
    // }),

    // 💰 Payout Details (nested)
    // columnHelper.accessor(
    //     (row) => row.payOut?.customerAccountInfo?.name,
    //     {
    //         id: "accountName",
    //         header: "Account Name",
    //         size: 180,
    //     }
    // ),

    // columnHelper.accessor(
    //     (row) => row.payOut?.customerAccountInfo?.accountNumber,
    //     {
    //         id: "accountNumber",
    //         header: "Account No",
    //         size: 180,
    //     }
    // ),

    // columnHelper.accessor(
    //     (row) => row.payOut?.customerAccountInfo?.ifsc,
    //     {
    //         id: "ifsc",
    //         header: "IFSC",
    //         size: 120,
    //     }
    // ),

    // columnHelper.accessor(
    //     (row) => row.payOut?.paymentChannel,
    //     {
    //         id: "paymentChannel",
    //         header: "Payment Channel",
    //         size: 140,
    //     }
    // ),

    // 🕒 Audit
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 180,
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 180,
    }),
    // columnHelper.accessor("newStatus", {
    //     header: "Status",
    //     size: 180,
    // }),
    columnHelper.accessor("reason", {
      header: "Reason",
      size: 180,
    }),
  ];

  if (roleResponse?.tradefailed?.update === 1) {
    columns.push(
      columnHelper.accessor("Actions", {
        header: "Status Update",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;

          return (
            <Box>
              {roleResponse?.tradefailed?.update === 1 && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      setOpen(true);
                      setFormData({
                        id: rowId || "",
                      });
                      document.getElementById("file-input").value = "";

                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    <EditIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      }),
    );
  }
  const flatData = useMemo(() => {
    if (!Array.isArray(historyData)) return [];

    return historyData.map((item) => ({
      _id: item._id || "",

      // Transaction details
      quoteId: item.quoteId || "",
      transactionRefNo: item.transactionRefNo || "",
      calculationType: item.calculationType || "",
      metalType: item.metalType || "",
      quantity: Number(item.quantity) || 0,
      metalRate: Number(item.metalRate) || 0,
      preTaxAmount: Number(item.preTaxAmount) || 0,
      totalAmount: Number(item.totalAmount) || 0,
      status: item.status || "",

      // Customer info
      customerName: item.customerName || "",
      customerNameInBatuk: item.customerNameInBatuk || "",
      customerNameInMmtc: item.customerNameInMmtc || "",
      mobileNoInBatuk: item.mobileNoInBatuk || "",
      mobileNoInMmtc: item.mobileNoInMmtc || "",
      panNoInBatuk: item.panNoInBatuk || "",
      panNoInMmtc: item.panNoInMmtc || "",

      dobInBatuk: item.dobInBatuk || "",
      dobInMmtc: item.dobInMmtc || "",

      customerRefNo: item.customerRefNo || "",

      // Payout (flattened ✅)
      accountName: item.payOut?.customerAccountInfo?.name || "",
      accountNumber: item.payOut?.customerAccountInfo?.accountNumber || "",
      ifsc: item.payOut?.customerAccountInfo?.ifsc || "",
      paymentChannel: item.payOut?.paymentChannel || "",

      // Dates
      createdAt: item.createdAt
        ? new Date(item.createdAt).toLocaleString()
        : "",
      updatedAt: item.updatedAt
        ? new Date(item.updatedAt).toLocaleString()
        : "",
    }));
  }, [historyData]);

  return (
    <div>
      {/* <div className="mb-6">
                <h3 className="text-3xl font-bold mb-2">Import &amp; Export Dashboard</h3>
                <p className="text-slate-500 dark:text-slate-400">Manage your data assets through automated report generation and bulk file uploads.</p>
            </div> */}

      {/* {uploadData &&
                <>
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-10" >
                        <div className="universal-card font-bold text-2xl">Total: {uploadData?.summary?.total}</div>
                        <div className="universal-card font-bold text-2xl">Processed: {uploadData?.summary?.processed}</div>
                        <div className="universal-card font-bold text-2xl">Executed: {uploadData?.summary?.executed}</div>
                        <div className="universal-card font-bold text-2xl">Failed: {uploadData?.summary?.failed}</div>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full border border-gray-300 rounded-xl">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-sm font-semibold">
                                        Row
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-sm font-semibold">
                                        Customer Ref No
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-sm font-semibold">
                                        Transaction Ref No
                                    </th>
                                    <th className="border border-gray-300 px-4 py-2 text-left text-sm font-semibold">
                                        Error
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {uploadData?.errors?.map((error, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="border border-gray-300 px-4 py-2 text-sm">
                                            {error.row}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm">
                                            {error.customerRefNo}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm">
                                            {error.transactionRefNo}
                                        </td>
                                        <td className="border border-gray-300 px-4 py-2 text-sm text-red-600">
                                            {error.error}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            } */}

      <div>
        <div>
          <form
            onSubmit={handleGetHistorySubmit}
            className="flex gap-4 mb-8 flex-col sm:flex-row md:flex-row"
          >
            <TextField
              fullWidth
              label="Start Date"
              size="small"
              type="date"
              name="startDate"
              value={date.startDate}
              onChange={handleDateChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              fullWidth
              label="End Date"
              size="small"
              type="date"
              name="endDate"
              value={date.endDate}
              onChange={handleDateChange}
              InputLabelProps={{ shrink: true }}
            />
            <LoadingButton
              type="submit"
              fullWidth
              // onClick={handleGetHistoryData}
              loading={historyLoading}
              variant={historyLoading ? "outlined" : "contained"}
            >
              Search
            </LoadingButton>
          </form>
        </div>
        {open && (
          <MuiSelectionModal
            open={open}
            onClose={() => setOpen(false)}
            value={status}
            onChange={(val) => setStatus(val)}
            formData={formData}
            setFormData={setFormData}
            getlistofusers={apicall}
          />
        )}
        <Box mt={2}>
          <CustomTable
            columns={columns}
            data={results}
            loading={loader}
            DataForExportAll={flatData}
            permissionKey="tradefailed"
          />
        </Box>
      </div>
    </div>
  );
}
